import { scrollLock } from './util';

const AllInTrainers = (() => {
    function openPopup() {
        $('.js-all-in-trainer-popup-link').on('click', (e) => {
            // element needs to be set visible before adding class
            $(e.currentTarget).next('.js-all-in-trainer-popup').css('display', 'flex');

            // timeouts needed for animation to follow
            setTimeout(() => {
                $(e.currentTarget).next('.js-all-in-trainer-popup').addClass('show');
                scrollLock('on');
            }, 10);
        });

        // Close popup
        $('.js-all-in-trainer-popup-close').on('click', (e) => {
            $(e.currentTarget).closest('.js-all-in-trainer-popup').removeClass('show');

            // set to animation out time in css
            setTimeout(() => {
                $(e.currentTarget).closest('.js-all-in-trainer-popup').css('display', 'none');
                scrollLock('off');
            }, 500);
        });

        $('.js-all-in-trainer-popup').on('click', () => {
            $('.js-all-in-trainer-popup').removeClass('show');

            // set to animation out time in css
            setTimeout(() => {
                $('.js-all-in-trainer-popup').css('display', 'none');
                scrollLock('off');
            }, 500);
        });

        // Prevent closing popup if click inside content
        $('.js-all-in-trainer-popup-wrap').on('click', (e) => {
            e.stopPropagation();
        });
    }

    return {
        init() {
            openPopup();
        },
    };
})();

export default (() => {
    $(document).ready(AllInTrainers.init);
})();
